var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoaded)?_c('section',{staticClass:"module",attrs:{"id":`module-${_vm.id}`}},[_c('div',{staticClass:"module__content"},[_vm._t("default")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }